'use strict'

import {isArray, isString, isNaN, toPath, toNumber, reduce, take, nth, last, head} from 'lodash'

/**
*  [root]  [sections]    [rows]      [columns]
* pageData.containers[0].children[0].children[0]
*
*/
class KeyPath {
    constructor(path) {
        this._pathArray = isArray(path) ? path : toPath(path)
        this._pathString = isString(path) ? path : reduce(this._pathArray, this._reduceToSting , "")
    }

    toArray() {
        return [...this._pathArray]
    }

    toString() {
        return this._pathString
    }

    get parent() {
        const parentPath = take(this.toArray(), this.length - 1)
        return new KeyPath(parentPath)
    }

    get length() {
        return this.toArray().length
    }

    get lastIndex() {
        return last(this.toArray())
    }

    get topElement() {
        return head(this.toArray())
    }

    getItemAt(index) {
        return nth(this.toArray(),index)
    }

    _reduceToSting(result, value, idx) {
        //if current value is a property and nor an index i.e. cant be converted to a number
        if (isNaN(toNumber(value))) {
            //if it is not the first one add a point in front of it
            if (idx!==0) {
                result +='.'
            }
        //add the property
        result += value
        //else if it is an array index
        } else {
            //add the index in array access operator
            result += '['+ value + ']'
        }
        return result
    }

}

export default KeyPath



// WEBPACK FOOTER //
// ./src/utils/KeyPath.js